import CustomerCategoriesDialog from './CustomerCategoriesDialog';

export default CustomerCategoriesDialog;
